import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import * as projectActions from "../../../actions/projectActions";
import * as modalActions from "../../../actions/modalActions";

import HeaderWrapper from "../../common/HeaderWrapper";
import ProjectNoteList from "./ProjectNoteList";
import ProjectNoteForm from "./ProjectNoteForm";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";

class ProjectNotesPage extends Component {
  constructor(props) {
    super(props);
    this.state = { note: {}, adding: false };
  }

  onClickAdd = () => {
    this.setState({ note: {}, adding: true });
    this.props.actions.showModalSuccess("projectDetailsModal");
  };

  onClickEdit = (noteId) => {
    const { project } = this.props;
    const note = project.notes.find((n) => n._id === noteId);
    this.setState({ note, adding: false });
    this.props.actions.showModalSuccess("projectDetailsModal");
  };

  onClickDelete = (noteId) => {
    this.props.actions.requestNoteId(noteId);
  };

  handleAdd = (note) => {
    const { project } = this.props;
    this.props.actions.createNote(project._id, note);
  };

  handleSave = (note) => {
    const { project } = this.props;
    this.props.actions.updateNote(project._id, note);
  };

  handleDelete = () => {
    const { project, projectNoteToDelete } = this.props;
    this.props.actions.deleteNote(project._id, projectNoteToDelete);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { project, isMobile, auth } = this.props;
    const { note, search, adding } = this.state;

    const noteForm = (
      <ProjectNoteForm
        auth={auth}
        project={project}
        note={note}
        adding={adding}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        saving={this.props.saving}
      />
    );

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: "Notes" }]}
          onClickEdit={this.handleEdit}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper transparent">
          <ProjectNoteList
            project={project}
            search={search}
            isMobile={isMobile}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
          <Modal
            id="projectDetailsModal"
            title={adding ? "Add Note" : "Edit Note"}
            body={noteForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="noteDeleteModal"
            title="Delete Note"
            body="Are you sure you want to delete this note?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </>
    );
  }
}

ProjectNotesPage.propTypes = {
  actions: PropTypes.object.isRequired,
  project: PropTypes.object,
  projectNoteToDelete: PropTypes.string,
  saving: PropTypes.bool,
  isMobile: PropTypes.bool,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    project: state.reducers.project,
    saving: state.reducers.savingProject,
    projectNoteToDelete: state.reducers.projectNoteToDelete,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...projectActions, ...modalActions },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(ProjectNotesPage)
);
